import { useState, useCallback, useEffect } from 'react';
import { api } from '../lib/api';
import { DEFAULT_SOURCES } from '../utils/constants';

export function useIncome(user, notify) {
  const [incomeData, setIncomeData] = useState([]);
  const [customSources, setCustomSources] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('customSources')) || [];
    } catch {
      return [];
    }
  });

  const fetchIncome = useCallback(async () => {
    try {
      const res = await api.get('/income');
      const sorted = [...res.data.entries].sort((a, b) => new Date(a.date) - new Date(b.date));
      setIncomeData(sorted);
    } catch (error) {
      console.error('Fetch income error', error);
    }
  }, []);

  useEffect(() => {
    if (user) fetchIncome();
  }, [user, fetchIncome]);

  const addCustomSource = useCallback(
    (name) => {
      if (name && !customSources.includes(name)) {
        const updated = [...customSources, name];
        setCustomSources(updated);
        localStorage.setItem('customSources', JSON.stringify(updated));
        notify?.(`Source "${name}" added!`, 'success');
        return true;
      }
      return false;
    },
    [customSources, notify]
  );

  const deleteCustomSource = useCallback(
    (name) => {
      const updated = customSources.filter((s) => s !== name);
      setCustomSources(updated);
      localStorage.setItem('customSources', JSON.stringify(updated));
      notify?.(`Source "${name}" removed`, 'success');
    },
    [customSources, notify]
  );

  return {
    incomeData,
    fetchIncome,
    customSources,
    addCustomSource,
    deleteCustomSource,
    allSources: [...DEFAULT_SOURCES, ...customSources],
  };
}
